import "./Conditions.module.css";
import Header from "@/reusable_sections/Header";
import UnderstandingYourCondition from "./sections/UnderstandingYourCondition";
import ConditionsWeTreat from "./sections/ConditionsWeTreat";
import Footer from "@/reusable_sections/Footer";
export default function ConditionsPage() {
  return <div>
      <Header />
      <UnderstandingYourCondition />
      <ConditionsWeTreat />
      <Footer />
    </div>;
}